import { useMatch } from '@reach/router';

const useSecurePage = () => {
    const isPathSecure = useMatch('/secure/*');
    return { isSecurePage: Boolean(isPathSecure) };
};

export default useSecurePage;
